module.exports = __webpack_public_path__ + "static/media/combat(2).ca85f69a.PNG";